import { ComponentType, useEffect } from "react";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { TrackerProgressDonut } from "UIPalette/TrackerProgress/TrackerProgress";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useNavigate } from "react-router-dom";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";

export type TrackerProgressTileProps = {
  trackerType: TrackerType;
  caption: string;
  trackerPagePath: string;
  Icon: ComponentType<React.SVGProps<SVGSVGElement>>;
  wrapInCard?: boolean;
  size?: "sm" | "lg" | "md";
};

type SizeWidths = { [K in Exclude<TrackerProgressTileProps["size"], undefined>]: string };

const sizeWidth: SizeWidths = {
  sm: "",
  md: "w-[5rem]",
  lg: "",
};

export const TrackerProgressTile = ({ trackerType, Icon, caption, trackerPagePath, wrapInCard, size = "lg" }: TrackerProgressTileProps) => {
  const navigate = useNavigate();
  const { getCurrentTrackerValue, getGoal, refreshCurrentTrackerData } = useTrackerContext();

  const current = getCurrentTrackerValue(trackerType);
  let goal = getGoal(trackerType);
  const percentage = current.percentageOf(goal);

  useEffect(() => {
    refreshCurrentTrackerData();
  }, [refreshCurrentTrackerData]);

  function renderBody() {
    const body = (
      <div className="flex flex-col items-center">
        <div className={`flex-grow ${sizeWidth[size]}`}>
          <TrackerProgressDonut TrackerIcon={Icon} percentage={percentage} size={size} />
        </div>
        <h3>
          <span className="text-brand-darker">{caption}</span>
        </h3>
      </div>
    );
    if (wrapInCard ?? true) {
      return <RoundedCard>{body}</RoundedCard>;
    }
    return body;
  }

  return <button onClick={() => navigate(`/${trackerPagePath}`)}>{renderBody()}</button>;
};
